import { SET_LOADING_INVENTORY_COUNTS } from './types';

export const setLoadingInventoryCounts = (payload) => {
	return {
		payload,
		type: SET_LOADING_INVENTORY_COUNTS
	};
};
